import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import DataInitialize from './views/DataInitialize.vue';
import Home from './views/Home.vue';
import Top from './views/Top.vue';
import Task from './views/Task.vue';
import TaskThread from './views/TaskThread.vue';
import Announcement from './views/Announcement.vue';
import AnnouncementList from './views/AnnouncementList.vue';
import Note from './views/Note.vue';
import NoteList from './views/NoteList.vue';
import NoteThread from './views/NoteThread.vue';
import Talk from './views/Talk.vue';
import TalkList from './views/TalkList.vue';
import TalkThread from './views/TalkThread.vue';

import store from './stores/index';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [   
        {
          path: '/',
          component: Top,
        },
        {
          path: '/task/:function_id/:task_id',
          name: 'task_detail',
          component: Task,
        },
        {
          path: '/task/:function_id/:task_id/:thread_id',
          name: 'thread_detail',
          component: TaskThread,
        },
        {
          path: '/announcement/:function_id',
          name: 'announcement',
          component: AnnouncementList,
        },
        {
          path: '/announcement/:function_id/:task_id',
          name: 'announcement_detail',
          component: Announcement,
        },
        {
          path: '/note/:function_id',
          name: 'note_detail',
          component: NoteList,
        },
        {
          path: '/note/:function_id/:task_id',
          name: 'note_detail',
          component: Note,
        },
        {
          path: '/note/:function_id/:task_id/:thread_id',
          name: 'thread_detail',
          component: NoteThread,
        },
        {
          path: '/talk/:function_id/',
          name: 'talk',
          component: TalkList,
        },
        {
          path: '/talk/:function_id/:task_id',
          name: 'talk',
          component: Talk,
        },
        {
          path: '/talk/:function_id/:task_id/:thread_id',
          name: 'thread_detail',
          component: TalkThread,
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/init',
      name: 'data_initialize',
      component: DataInitialize
    },
  ],
});

router.beforeEach((to, from, next) => { 
  if (to.name != 'login' && !store.state.login.isAuth) {
    next('/login');
    return
  }
  next();
});


export default router;